// extracted by mini-css-extract-plugin
export default {"card":"G5-z"};